import { disponibilidadLabel } from "@/lib/affiliateEstados";
import { Chip, DetailSection, EmptyLine } from "./AfiliadoDetailBits";
import type { AfiliadoVehiculo } from "@/types";

interface AfiliadoVehiculosProps {
  vehiculos: AfiliadoVehiculo[];
}

export default function AfiliadoVehiculos({ vehiculos }: AfiliadoVehiculosProps) {
  return (
    <DetailSection title={`Vehículos registrados (${vehiculos.length})`} icon="ri-truck-line">
      {vehiculos.length === 0 ? (
        <EmptyLine>No se registraron vehículos.</EmptyLine>
      ) : (
        <div className="space-y-4">
          {vehiculos.map((vehiculo, index) => {
            const tipo = vehiculo.tipo === "Otro" ? vehiculo.tipo_personalizado : vehiculo.tipo;
            return (
              <div
                key={vehiculo.id}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
              >
                <div className="flex flex-col gap-4 p-4 sm:flex-row">
                  <div className="flex h-28 w-full shrink-0 items-center justify-center overflow-hidden rounded-md border border-background-200 bg-background-50 sm:w-40">
                    {vehiculo.foto_url ? (
                      <img
                        src={vehiculo.foto_url}
                        alt=""
                        className="h-full w-full object-cover object-top"
                      />
                    ) : (
                      <i className="ri-image-line text-2xl leading-none text-foreground-400" aria-hidden="true"></i>
                    )}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-xs font-label font-semibold text-background-50">
                        {index + 1}
                      </span>
                      <h4 className="text-sm font-heading font-semibold text-foreground-950">
                        {[vehiculo.marca, vehiculo.modelo].filter(Boolean).join(" ") || "Vehículo"}
                      </h4>
                      <Chip>{disponibilidadLabel(vehiculo.disponibilidad)}</Chip>
                    </div>
                    <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3">
                      <DetailItem label="Tipo" value={tipo} />
                      <DetailItem label="Año" value={vehiculo.anio} />
                      <DetailItem label="Color" value={vehiculo.color} />
                      <DetailItem label="Placa" value={vehiculo.placa} />
                      <DetailItem label="Capacidad" value={vehiculo.capacidad} />
                      <DetailItem label="Tipo de carga" value={vehiculo.tipo_carga} />
                      <DetailItem label="Zona" value={vehiculo.zona_operacion} />
                      <DetailItem label="Días" value={vehiculo.dias_disponibles} />
                      <DetailItem label="Horario" value={vehiculo.horario} />
                      <DetailItem label="Distancia máx." value={vehiculo.distancia_maxima} />
                    </dl>
                    {(vehiculo.caracteristicas ?? []).length > 0 && (
                      <div className="mt-3 flex flex-wrap gap-1.5">
                        {(vehiculo.caracteristicas ?? []).map((caracteristica) => (
                          <span
                            key={caracteristica}
                            className="rounded-full border border-secondary-200 bg-secondary-50 px-2.5 py-0.5 text-[11px] font-label text-secondary-900"
                          >
                            {caracteristica}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </DetailSection>
  );
}

function DetailItem({ label, value }: { label: string; value?: string | null }) {
  return (
    <div className="min-w-0">
      <dt className="text-[11px] font-label uppercase tracking-wide text-foreground-500">{label}</dt>
      <dd className="truncate text-sm font-medium text-foreground-900">
        {value && String(value).trim() ? value : "—"}
      </dd>
    </div>
  );
}